/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import t from"./Dictionary.js";class s extends t{constructor(t){super(),this.immutable=!1,this.setField("url",t),this.immutable=!0}}export{s as default};
